import { render } from "./PrivacyVisitors.vue?vue&type=template&id=56f53a05"
const script = {}

import exportComponent from "/home/leviathan/sites/webbank/webbank-static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__